import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestStatsGet = {
    path: "/stats",
    method: RouteHttpVerb.GET
};
export { locationRestStatsGet };
